<template>
  <b-modal
    id="option-migration"
    ref="option-migration"
    title="Migrar identificador del Grupo de opciones"
    hide-footer
    no-close-on-backdrop
    size="xl"
  >
    <div
      class="row mb-5"
      v-if="option"
    >
      <div
        class="col-md-8 col-12 mt-3"
        v-if="isList"
      >
        <label>Migrar {{ this.option.length }} opciones</label>
      </div>
      <div
        class="col-md-8 col-12 mt-3"
        v-if="!isList"
      >
        <label>Nombre de la opción</label>
        {{ option.descripcion }}
      </div>
      <div class="col-md-12 mt-3">
        <label>Ambiente destino</label>
        <v-select
          v-model="environmentsToMigrate"
          multiple
          label="title"
          :options="availableEnvironments"
        />
      </div>

      <div class="col-md-12 mt-3">
        <div style="float: right">
          <vs-button
            class="action"
            color="primary"
            type="border"
            icon="save"
            @click="sendMigrationOption()"
            v-if="!isSavingOption"
          >
            Guardar
          </vs-button>
          <b-spinner
            v-else
            key="primary"
            class="mr-1"
            variant="primary"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>

import { OPTION_LEVELS } from '@/febos/global/empresas/componentes/options/OptionConfigurationsMixin';
import { ioMigrateOption } from '@/febos/servicios/api/herramientas.api';

const environments = [
  {
    title: 'Desarrollo',
    value: 'desarrollo'
  },
  {
    title: 'Pruebas',
    value: 'pruebas'
  },
  {
    title: 'Certificación',
    value: 'certificacion'
  },
  {
    title: 'Produccion',
    value: 'produccion'
  }
];

export default {
  name: 'OptionMigrationModal',
  data() {
    return {
      isSavingOption: false,
      isList: false,
      environmentsToMigrate: [],
      option: {}
    };
  },
  computed: {
    availableEnvironments() {
      return environments.filter((enviroment) => enviroment.value !== process.env.VUE_APP_AMBIENTE);
    }
  },
  methods: {
    migrateOptionGroup(option) {
      this.option = option;
      this.environmentsToMigrate = [];
      this.$refs['option-migration'].show();
    },
    async sendMigrationOption() {
      this.isSavingOption = true;
      try {
        const param = {
          global: this.option.nivel === OPTION_LEVELS.GLOBAL ? 'si' : 'no'
        };
        const environmentsToSend = this.environmentsToMigrate.map((enviroment) => enviroment.value);
        const body = { destinos: environmentsToSend };
        if (!this.isList) {
          param.id = this.option.opcionId;
        } else {
          body.ids = this.option.map((item) => item.opcionId);
        }
        await ioMigrateOption(param, body);
        this.isSavingOption = false;
        this.$refs['option-migration'].hide();
      } catch (e) {
        this.isSavingOption = false;
      }
    },
    setOption(option) {
      this.isList = Array.isArray(option);
      this.option = option;
    },
    show() {
      this.environmentsToMigrate = [];
      this.$refs['option-migration'].show();
    },
    hide() {
      this.$refs['option-migration'].hide();
    }
  }
};
</script>
